module.exports = "<div data-component=\"main-title\">\n\t<h2 class=\"title\" [style.color] = \"primaryColor\" *ngIf=\"title\">{{title}}</h2>\n\t<p class=\"subtitle\" *ngIf=\"subtitle\" [innerHtml]=\"subtitle\"></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/main-title/main-title.component.html
// module id = ../../../../../src/app/shared/main-title/main-title.component.html
// module chunks = main